// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// 饿了么UI框架
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
// 路由
import router from './router'
// ajax
import Axios from 'axios'
// 引入vuex
import {
  store
} from './store'
// 引入babel
import 'babel-polyfill'
// 引入初始化样式
import 'normalize.css'
// 引入接口API
import api from './api/index'
// 数据格式化
import qs from 'qs'
// 时间格式化
import moment from 'moment'
// 引入echarts
import Echarts from 'echarts'
// 引入Excel解析
import XLSX from 'xlsx'
// 引入轮播插件
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'
// 引入样式表
import '@/styles/index.scss'
// 引入图标字体Font
import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  fas
} from '@fortawesome/free-solid-svg-icons'
import {
  far
} from '@fortawesome/free-regular-svg-icons'
import {
  fab
} from '@fortawesome/free-brands-svg-icons'
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText
} from '@fortawesome/vue-fontawesome'

library.add(fas, far, fab)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)
Vue.prototype.$axios = Axios
Vue.prototype.$api = api
Vue.prototype.$qs = qs
Vue.prototype.$echarts = Echarts
Vue.prototype.$XLSX = XLSX
Vue.prototype.$moment = moment
Vue.config.productionTip = true
/* axios配置，增加页面跳转配置 */
Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
Axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 410 &&
      error.response.headers &&
      error.response.headers.location
    ) {
      window.location = error.response.headers.location
    } else {
      return Promise.reject(error)
    }
  }
)
// 设置cookie,放在main.js
Vue.prototype.setCookie = function (cName, value, expiredays) {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie = cName + '=' + escape(value) +
    ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
}
// 获取cookie
Vue.prototype.getCookie = function (cName) {
  if (document.cookie.length > 0) {
    var cStart = document.cookie.indexOf(cName + '=')
    if (cStart !== -1) {
      cStart = cStart + cName.length + 1
      var cEnd = document.cookie.indexOf(';', cStart)
      if (cEnd === -1) cEnd = document.cookie.length
      return unescape(document.cookie.substring(cStart, cEnd))
    }
  }
  return ''
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js